export class Brand {
	id = null;
	name = null;
	logo = null;

	constructor(data) {
		Object.assign(this, data);
	}

	isSame(otherBrand) {
		return (
			this.id == otherBrand.id && this.name == otherBrand.name && this.logo == otherBrand.logo
		);
	}
}
